module.exports = __webpack_public_path__ + "img/logo.c0291920.png";